module.exports = __webpack_public_path__ + "static/media/cq_imbuto.84b422d0.svg";